import axios from './../../config/axios';

function create(data) {
    return axios().post(`/stock/items`, data);
}

function findByID(id) {
    return axios().get(`/stock/items/${id}`, {
        params: {
            relations: ["measure_units", "accounts"]
        }
    });
}

function update(data) {
    return axios().put(`/stock/items/${data.id}`, data);
}

function remove(data) {
    return axios().delete(`/stock/items/${data.id}`);
}

function index(params) {
    params.limit = params.itemsPerPage;
    params.offset = (params.page - 1) * params.itemsPerPage;
    return axios().get(`/stock/items`, { params });
}

function search(query) {
    return axios().get(`/stock/items-search`, {
        params: {
            search: query
        }
    });
}

export function getItemMeasureUnits(itemId) {
    return axios().get(`/stock/items/${itemId}/measure-units`)
}

export function getItemUnitValue(itemId, warehouseId, measureUnitId, date) {
    const params = {
        item_id: itemId,
        measure_unit_id: measureUnitId,
        warehouse_id: warehouseId,
        date
    }

    return axios().get(`/stock/items/${itemId}/average-cost`, { params })
}

export function getAvailableQuantity(itemId, warehouseId, measureUnitId) {
    const params = {
        item_id: itemId,
        measure_unit_id: measureUnitId,
        warehouse_id: warehouseId,
    }

    return axios().get(`/stock/items/${itemId}/available-quantity`, { params })
}

export default {
    create,
    findByID,
    update,
    remove,
    index,
    search
}